import { useState } from 'react'
import {
  AppBar as MuiAppBar,
  Button,
  Divider,
  Drawer,
  Grid,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemText,
  Toolbar,
} from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import CloseIcon from '@material-ui/icons/Close'
import useStyles from './styles'
import {
  BABYLIST_URL,
  DME_ZENDESK_URL,
  HOME_PATH,
} from '../../../dme/constants'

export default function AppBar() {
  const classes = useStyles()

  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  return (
    <div className={classes.root}>
      <MuiAppBar className={classes.appBar} elevation={4} position="sticky">
        <Toolbar>
          <Grid container direction="row">
            <Grid item xs>
              <IconButton
                aria-label="menu"
                className={classes.menuButton}
                onClick={() => setIsDrawerOpen(true)}
              >
                <MenuIcon />
              </IconButton>
              <Button className={classes.linkButton} href={BABYLIST_URL}>
                Babylist
              </Button>
            </Grid>
            <Grid item xs className={classes.title}>
              <Link aria-label="Visit homepage" href={HOME_PATH}>
                <img
                  alt="Babylist Health Logo"
                  src="//res.cloudinary.com/babylist/image/upload/v1662486788/DME/logo_babylist-health.svg"
                />
              </Link>
            </Grid>
            <Grid item xs className={classes.rightGrid}>
              <Button className={classes.linkButton} href={DME_ZENDESK_URL}>
                Help
              </Button>
            </Grid>
          </Grid>

          <Drawer open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)}>
            <List className={classes.list}>
              <ListItem className={classes.menuHeader} disableGutters>
                <IconButton
                  className={classes.closeButton}
                  onClick={() => setIsDrawerOpen(false)}
                  edge="start"
                >
                  <CloseIcon />
                </IconButton>
                <img
                  alt="Babylist Health Logo"
                  src="//res.cloudinary.com/babylist/image/upload/v1662486788/DME/logo_babylist-health.svg"
                  width={118}
                />
              </ListItem>
              <ListItem
                className={classes.listItemLink}
                component="a"
                href={HOME_PATH}
              >
                <ListItemText primary="Home" />
              </ListItem>
              <ListItem
                className={classes.listItemLink}
                component="a"
                href={DME_ZENDESK_URL}
              >
                <ListItemText primary="Help Center" />
              </ListItem>
              <Divider className={classes.menuDivider} />
              <ListItem
                className={classes.listItemLink}
                component="a"
                href={BABYLIST_URL}
              >
                <ListItemText
                  primary="Babylist"
                  secondary="Registry and Shop"
                />
              </ListItem>
            </List>
          </Drawer>
        </Toolbar>
      </MuiAppBar>
    </div>
  )
}
